// form/defaultValues.ts
import { PreLodgementChecklistFormValues } from '../types/preLodgementChecklist';

// Australian FY runs 1 Jul – 30 Jun. We name the FY by the calendar year it ENDS in.
// Jul–Dec → FY ends next calendar year. Jan–Jun → FY ends this calendar year.
export const getCurrentFY = (): number => {
  const now = new Date();
  return now.getMonth() >= 6 ? now.getFullYear() + 1 : now.getFullYear();
};

export const DEFAULT_PRELODGMENT_CHECKLIST_VALUES: PreLodgementChecklistFormValues =
  {
    // --- Step 1: Personal Details
    taxFinancialYear: getCurrentFY(),
    citizenship: '',
    taxResidencyStatus: '',

    // --- Step 2: Property Income
    propertyDisposalAnswer: null,
    propertyDisposalNotes: '',
    propertyRefinanceAnswer: null,
    propertyRefinanceNotes: '',
    propertyPurchaseAnswer: null,
    propertyPurchaseNotes: '',

    // --- Step 3: Other Income
    incomeSource: '',
    employer: '',
    annualSalary: '',
    annualSalaryCurrency: 'AUD',
    bonusesAndBenefits: '',
    bonusesAndBenefitsCurrency: 'AUD',
    dividendAnswer: null,
    cryptoAnswer: null,
    shareDisposalAnswer: null,

    // --- Step 4: Future Plans
    planningToBuyAnswer: null,
    planningToBuyNotes: '',
    propertySaleAnswer: null,
    propertySaleNotes: '',
    repatriationAnswer: null,
    repatriationDate: '',

    // --- Step 5: Additional Details
    additionalQuestions: '',
    wantsMortgageReview: null,
  };
